import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./styles/automotive-theme.css";
import "./styles/typography.css";
import "./styles/global-premium.css";
import "./styles/offer-section.css";
import "./styles/advantage-section.css";
import "./styles/client-stories-section.css";
import "./styles/how-it-works-section.css";
import "./styles/footer-section.css";
import "./styles/premium-international.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { BrowserRouter } from "react-router-dom";
import "semantic-ui-css/semantic.min.css";
import Data from './data/datafile'

import { PersistGate } from 'redux-persist/integration/react'
import { GoogleOAuthProvider } from "@react-oauth/google";
import { bootstrapAuthExpiryHandling } from "./utils/sessionExpiry";
import config from "./config";

bootstrapAuthExpiryHandling();

  
  // Data=av

  fetch(`/data/datafile.json`).then((response) => {
    response.json().then((data) => {
      const appTree = (
        <Provider store={store.store}>
          <PersistGate loading={null} persistor={store.persistor}>
            <BrowserRouter>
              <App data={data} />
            </BrowserRouter>
          </PersistGate>
        </Provider>
      );

      ReactDOM.render(
        <React.StrictMode>
          {config.googleClientId ? (
            <GoogleOAuthProvider clientId={config.googleClientId}>
              {appTree}
            </GoogleOAuthProvider>
          ) : (
            appTree
          )}
        </React.StrictMode>,
        document.getElementById("root")
      );
    });
  });





// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
